import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "@/providers";
import { AppRoutes } from "@/routes";

const PROTECTED_PAGES = [
  AppRoutes.ABOUT(),
  AppRoutes.HOME(),
  AppRoutes.LIBRARY(),
  AppRoutes.SETTINGS(),
  AppRoutes.STORIES(),
];

export const useAuthRedirect = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, loading } = useAuth();

  const { AUTH, HOME, ROOT, SIGN_IN, SIGN_UP } = AppRoutes;

  useEffect(() => {
    if (loading) return;

    const isRequestingAuth = [AUTH(), SIGN_IN(), SIGN_UP()].includes(pathname);
    const isRequestingProtected = PROTECTED_PAGES.includes(pathname);
    const isRequestingRoot = pathname === ROOT();

    // Signed-in users on auth/root → home
    if (user && (isRequestingAuth || isRequestingRoot)) {
      navigate(HOME());
      return;
    }

    // Signed-out users on protected pages → root (Landing)
    if (!user && isRequestingProtected) {
      navigate(ROOT());
    }
  }, [AUTH, HOME, ROOT, SIGN_IN, SIGN_UP, loading, navigate, pathname, user]);
};
